import { SEARCH_MAX_LENGTH, SEARCH_MIN_LENGTH } from '@/constants/contentFeed';

// Mirror of the backend's MongoDB text-search sanitizer
// (content-search.util.ts → sanitizeMongoTextSearchQuery): every operator character is
// replaced with a space, then whitespace is collapsed and trimmed. Matching it exactly is
// what lets the client decide "this won't reach the min length" locally instead of firing
// a request the backend will 400 — e.g. `a+` → `a` (too short), `++` → `` (empty).
//
// Keep this set identical to MONGO_TEXT_SEARCH_OPERATORS on the backend.
const OPERATOR_PATTERN = /[+\-"!(){}[\]^~*?:\\/|&]/g;

export const sanitizeSearchQuery = (q: string): string =>
  q.replace(OPERATOR_PATTERN, ' ').replace(/\s+/g, ' ').trim();

export const isSearchable = (q: string): boolean => {
  const sanitized = sanitizeSearchQuery(q);

  return sanitized.length >= SEARCH_MIN_LENGTH && sanitized.length <= SEARCH_MAX_LENGTH;
};
